import { TransactionType } from 'enum/transaction-type';
import { Limit } from 'types/custom/common';
import { formatNumberToCurrency } from 'utils/formatters';
import * as Yup from 'yup';

const commonSchema = {
  stock: Yup.string().required('Stock is required'),
  price: Yup.number().required('Price is required').min(0, 'Price must be greater than or equal to 0'),
  orderType: Yup.string().required('Order Type is required'),
  quantity: Yup.number().required('Quantity is required').min(1, 'Quantity must be greater than 0')
};

function placeOrderValidationSchema(sl: boolean, limit?: Limit | null) {
  let priceSchema = Yup.number().required('Price is required').min(0, 'Price must be greater than or equal to 0');
  let triggerPriceSchema = Yup.number();

  if (limit) {
    if (limit.lowerLimit !== undefined) {
      priceSchema = priceSchema.min(
        limit.lowerLimit,
        `The limit price can't be lesser than the lower circuit price ${formatNumberToCurrency(limit.lowerLimit ?? 0, true)}.`
      );
      // triggerPriceSchema = triggerPriceSchema.min(
      //   limit.lowerLimit,
      //   `Trigger price must be greater than or equal to ${formatNumberToCurrency(limit.lowerLimit)}`
      // );
    }
    if (limit.upperLimit !== undefined) {
      priceSchema = priceSchema.max(
        limit.upperLimit,
        `The limit price can't be greater than the upper circuit price ${formatNumberToCurrency(limit.upperLimit ?? 0, true)}.`
      );
      // triggerPriceSchema = triggerPriceSchema.max(
      //   limit.upperLimit,
      //   `Trigger price must be less than or equal to ${formatNumberToCurrency(limit.upperLimit)}`
      // );
    }
  }

  if (sl) {
    triggerPriceSchema = triggerPriceSchema
      .test('trigger-price-validation', 'Invalid trigger price', function (value: number | undefined) {
        if (!value) {
          value = 0;
        }
        const { price } = this.parent;
        if (value < price) {
          return this.createError({ message: 'Trigger price must be greater than or equals to the price' });
        }
        return true;
      })
      .required('Trigger price is required');
  }

  return Yup.object().shape({
    ...commonSchema,
    price: priceSchema,
    ...(sl && { triggerPrice: triggerPriceSchema })
  });
}

export function placeOrderValidationSchemaV2(sl: boolean, type: TransactionType | null, limit?: Limit | null) {
  let priceSchema = Yup.number().required('Price is required').min(0, 'Price must be greater than or equal to 0');
  let triggerPriceSchema = Yup.number();

  if (limit) {
    if (limit.lowerLimit !== undefined) {
      priceSchema = priceSchema.min(
        limit.lowerLimit,
        `The limit price can't be lesser than the lower circuit price ${formatNumberToCurrency(limit.lowerLimit ?? 0, true)}.`
      );
    }
    if (limit.upperLimit !== undefined) {
      priceSchema = priceSchema.max(
        limit.upperLimit,
        `The limit price can't be greater than the upper circuit price ${formatNumberToCurrency(limit.upperLimit ?? 0, true)}.`
      );
    }
  }

  if (sl) {
    triggerPriceSchema = triggerPriceSchema
      .test('trigger-price-validation', 'Invalid trigger price', function (value: number | undefined) {
        if (value === undefined) return this.createError({ message: 'Trigger price is required' });

        const { price } = this.parent;

        if (type === 'BUY' && value > price) {
          return this.createError({ message: 'Trigger price must be less than or equal to the price for BUY orders' });
        }

        if (type === 'SELL' && value < price) {
          return this.createError({ message: 'Trigger price must be greater than or equal to the price for SELL orders' });
        }

        return true;
      })
      .required('Trigger price is required');
  }

  return Yup.object().shape({
    ...commonSchema,
    price: priceSchema,
    ...(sl && { triggerPrice: triggerPriceSchema })
  });
}

export default placeOrderValidationSchema;
